module.exports = __webpack_public_path__ + "media/shared/images/apple-touch-icon-ipad-retina-ce09388545f322266f1d7b8a9e36fab1.png";